import React from 'react';
import { Base } from './Base';
import { Text, TextLink } from './Text';
import { Link } from 'react-router-dom';
import { ChartIconGrey } from './icons';
import { mpEvent, MPEvents } from 'src/utils/mixpanel';

interface EPAssessmentVersionPublishedProps {
  assessment: {
    id: string;
    name: string;
  };
  version: {
    id: string;
    name: string;
  };
  isToday?: boolean;
}

export const EPAssessmentVersionPublished: React.FC<EPAssessmentVersionPublishedProps> = ({
  assessment,
  version,
  isToday,
}) => {
  return (
    <Base
      iconComponent={<ChartIconGrey />}
      constentComponent={
        <Text $isPast={!isToday}>
          Version{' '}
          <Link
            to={`/risk-assessments/${assessment.id}?version=${version.id}`}
            onClick={() =>
              mpEvent(MPEvents.Link, {
                source: {
                  value: ['Timeline'],
                },
                destination: {
                  value: ['Assessment'],
                  params: {
                    id: assessment.id,
                  },
                },
                tags: ['ASSESSMENT'],
              })
            }
          >
            <TextLink $isPast={!isToday}>{version.name}</TextLink>
          </Link>{' '}
          of assessment{' '}
          <Link
            to={`/risk-assessments/${assessment.id}`}
            onClick={() =>
              mpEvent(MPEvents.Link, {
                source: {
                  value: ['Timeline'],
                },
                destination: {
                  value: ['Assessment'],
                  params: {
                    id: assessment.id,
                  },
                },
                tags: ['TIMELINE', 'ASSESSMENT'],
              })
            }
          >
            <TextLink $isPast={!isToday}>{assessment.name}</TextLink>
          </Link>{' '}
          published.
        </Text>
      }
    />
  );
};
